import React from "react";
import { Dialog, Flex, Text, TextField, Button } from "@radix-ui/themes";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";

export function AuthKlaviyoDialog({
  isOpen,
  onOpenChange,
  onCancel,
  onSave,
  handleApiKeyChange,
  isApiKeyValid,
  isLoading,
  title = "Connect Klaviyo",
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="600px" maxHeight="690px" align="center">
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          To find your API key, log into Klaviyo and go to Account → Settings → API Keys to copy or create one.
          See Klaviyo's documentation for details.
        </Dialog.Description>

        <Flex className="slot-container" style={{ alignSelf: "stretch" }} display="flex" direction="row" align="start" gap="5">
          <Flex className="api-key-field" style={{ flex: 1 }} display="flex" direction="column" align="start" gap="1">
            <Text size="2" weight="medium">
              API key
            </Text>
            <TextField.Root
              onChange={handleApiKeyChange}
              placeholder="Paste your Klaviyo API key here"
              style={{ width: "100%" }}
              size="2"
              variant="surface"
            />
            {!isApiKeyValid && (
              <Text size="1" weight="regular" color="red">
                Please enter a valid API key.
              </Text>
            )}
          </Flex>
        </Flex>

        <Flex
          style={{
            alignSelf: "stretch",
            width: "100%",
          }}
          display="flex"
          justify="between"
          align="center"
          mt="4"
        >
          <Button
            size="2"
            variant="ghost"
            color="gray"
            onClick={() => window.open("https://www.klaviyo.com/docs", "_blank")}
          >
            <Flex display="flex" align="center" gap="2">
              Open Klaviyo Docs
              <ArrowTopRightOnSquareIcon style={{ width: "16px", height: "16px" }} />
            </Flex>
          </Button>

          <Flex display="flex" gap="3" justify="end">
            <Dialog.Close>
              <Button onClick={onCancel} size="2" variant="soft" color="gray">
                Cancel
              </Button>
            </Dialog.Close>
            <Button onClick={onSave} size="2" variant="soft" color="accent" loading={isLoading}>
              Save and continue
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
